__turbopack_context__.v({
  "cardsWrapper": "qVVFjq_cardsWrapper",
  "listContainer": "qVVFjq_listContainer",
  "listFooter": "qVVFjq_listFooter",
  "marginTop": "qVVFjq_marginTop",
  "noRestaurantsPlaceholder": "qVVFjq_noRestaurantsPlaceholder",
  "outletsSectionHeader": "qVVFjq_outletsSectionHeader",
  "skeletonCard": "qVVFjq_skeletonCard",
});
